import { format } from 'date-fns';
import { getDateFromApiDate } from '../dates';

// 'YYYY-MM-DD'
const displayDate = articleDate => {
    if (!articleDate) return null;
    const date = getDateFromApiDate(articleDate);
    return format(date, 'MMMM d, y');
};

export const mapSearchSessionToProps = (props) => {
    const hit = props?.hit || props;

    if (!hit || !hit.objectID) {
        return { id: 0, title: '', slug: '', sessionTracks: [], sessionStartUnix: 0, sessionEndUnix: 0 };
    }

    const idParts = typeof hit.objectID === 'string' ? hit.objectID.split('-') : [];
    const id = idParts.length > 1 ? parseInt(idParts[1], 10) : (hit.entry_id || 0);

    const getVal = (field) => (field && typeof field === 'object' ? field.value : field) || '';

    return {
        hit,
        id,
        slug: getVal(hit.slug),
        title: getVal(hit.title),
        url: hit.url || '',
        sessionType: Array.isArray(hit.session_type) ? getVal(hit.session_type[0]) : getVal(hit.session_type),
        sessionStatus: hit.session_status || [],
        sessionStartUnix: Number(hit.session_start_time) || 0,
        sessionEndUnix: Number(hit.session_end_time) || 0,
        sessionRoom: getVal(hit.session_room),
        photoURL: hit.photo_url || null,
        description: getVal(hit.description),
        event: hit.event || {},
        isFavorite: !!props.isFavorite,
        sessionTracks: Array.isArray(hit.session_tracks)
            ? hit.session_tracks.map(t => (typeof t === 'object' ? t.value : t))
            : [],
    };
};
